import React from 'react';
import styled from 'styled-components';
import text from "./text";
import Panorama from "./panorama"
import ItemQA from "./itemQA"
import {
  isAndroid,
  isIOS
} from "react-device-detect";

const Wrap = styled.div`
  margin: 100px 0;
  text-align: left;
`;
const Icon = styled.div`
  width:100px;
  height:100px;
  float: left;
  border: 2px solid white;
  border-radius: 50%;
  background-image: url(${props => (props.image)});
  background-size: 142%;
  background-position: ${props => (props.image ==='./img/content/Taucher.png'?'center top':'center top 14%')};
  background-repeat: no-repeat;
  background-color: ${props => (props.theme.colors.bg)};
  @media (max-width: ${props => (props.theme.breaks.mobile)}px) {
    width:65px;
    height:65px;
  }
`;
const CharacterName = styled(text.H2)`
  padding: 49px 0 0 112px;
  font-weight: bold;
  margin:0 !important;
  font-size: 1.5em !important;
  @media (max-width: ${props => (props.theme.breaks.mobile)}px) {
    padding: 40px 0 0 80px;
    font-size: 1em !important;
  }
`;


function ContentItems(props) {
  const items = props.items || [];
  const listItems = items.map((item,i) =>
    <div key={i.toString()} id={item.pref.replace(/[^A-Z0-9]+/ig, "_")+item.name.replace(/[^A-Z0-9]+/ig, "_")+"_"+i.toString()}>
      <Icon image={item.image} alt={item.name + " image"} />
      <CharacterName>{item.name}</CharacterName>
      <br style={{clear:'both'}} />
      <Panorama item={item} activeFrame={props.activeFrame} index={i} handleClick={props.handleClick}></Panorama>
      <ItemQA text={item.text} question={item.question} info={item.info} answer={item.answer} Antwort={props.Antwort} isReady={item.views.length>0} notReadyContent={props.notReadyContent} />
    </div>
  );
  return (
    <Wrap>{listItems}</Wrap>
  );
}

export default class Content extends React.Component {
  constructor(props) {
    super(props);
    this.state = {activeFrame: null};
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(active) {
    //console.log(active);
    if(isAndroid || isIOS){
      console.log("open view "+active+" in new window");
      console.log(this.props.items[active]);
      console.log(this.props.items[active].views[0]);
      if(this.props.items[active].views[0] !== undefined){
        window.open(this.props.items[active].views[0]);
      }
    }else{
      this.setState(state => ({
        activeFrame: active
      }));
    }
  }
  render() {
    return (
        <ContentItems items={this.props.items} activeFrame={this.state.activeFrame} handleClick={this.handleClick} Antwort={this.props.Antwort} notReadyContent={this.props.notReadyContent} />
    )
  }
}
